/* global axios */
import ApiClient from '../ApiClient';

class WizardPreferences extends ApiClient {
  constructor() {
    super('wizard/preferences', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  updatePreferences(data) {
    return axios.put(this.url, data);
  }
}

export default new WizardPreferences();
